"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _core = require("@material-ui/core");
var _classnames = _interopRequireDefault(require("classnames"));
var Table = function Table(_ref) {
  var columns = _ref.columns,
    data = _ref.data,
    scrollClasses = _ref.scrollClasses,
    showScroll = _ref.showScroll;
  var refundRowClasses = (0, _classnames.default)('refunds-history-table__row', {
    'refunds-history-table__row--noScroll': !showScroll
  });
  return /*#__PURE__*/_react.default.createElement(_core.TableContainer, {
    className: scrollClasses
  }, /*#__PURE__*/_react.default.createElement(_core.Table, {
    stickyHeader: true,
    "aria-label": "Refunds History",
    className: "refunds-history-table",
    "data-test-id": "refunds-history-table"
  }, /*#__PURE__*/_react.default.createElement(_core.TableHead, null, /*#__PURE__*/_react.default.createElement(_core.TableRow, {
    "data-testid": "refunds-history-table-header",
    className: refundRowClasses
  }, columns.map(function (column) {
    var content = column.header;
    return /*#__PURE__*/_react.default.createElement(_core.TableCell, {
      key: column.id,
      align: column.align,
      className: "refunds-history-table__cell"
    }, content);
  }))), /*#__PURE__*/_react.default.createElement(_core.TableBody, null, data.map(function (rowData) {
    return /*#__PURE__*/_react.default.createElement(_core.TableRow, {
      key: rowData.refundId,
      className: refundRowClasses,
      "data-test-id": "refunds-history-table-row"
    }, columns.map(function (column) {
      var content = rowData[column.field];
      return /*#__PURE__*/_react.default.createElement(_core.TableCell, {
        key: "".concat(column.id, "-").concat(rowData.refundId),
        align: column.align,
        className: column.className
      }, content);
    }));
  }))));
};
Table.propTypes = {
  columns: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})).isRequired,
  data: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})).isRequired,
  scrollClasses: _propTypes.string.isRequired,
  showScroll: _propTypes.bool.isRequired
};
var _default = exports.default = Table;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-refunds/lib/components/Table/styles.scss');